import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { isTokenExpired, limpiaLocalStorage } from '../../project/utils/utils';
import AuthContext from "../../project/contexts/AuthContext";
import { jwtDecode } from "jwt-decode";

const Analytics = () => {
  const [storageContent, setStorageContent] = useState([]);
  const navigate = useNavigate();
  const { setAuth } = useContext(AuthContext);

  useEffect(() => {

    const _token = localStorage.getItem("token");
    const _tokenExp = localStorage.getItem("token_exp");

    if (isTokenExpired(_token, _tokenExp)) {
      // si no hay token o el token expiró, se limpia el localStorage y se redirige al login

      limpiaLocalStorage();
      navigate('/login');
    } else {
      // si el token es valido

      const _decodedToken = jwtDecode(_token);
      setAuth({
        roles: _decodedToken.roles,
        permisos: _decodedToken.permissions,
        token: _token,
        user: _decodedToken.user,
      });
    }
  }, []);

  return (
    <></>
  );
};
export default Analytics;
